<section
  class="flex flex-col justify-between gap-4 bg-gradient-to-r from-[#0b254e] to-[#154fa0] py-6 text-white md:flex-row"
>
  <app-totals-display
    class="mt-4 hidden w-full flex-col self-center px-4 md:mt-0 md:block md:flex-1 md:px-0 md:pr-0"
    [activeLocations]="(totalActiveLocations$ | async) || 0"
    [activeOrders]="(activeOrders$ | async)?.length || 0"
  ></app-totals-display>

  <app-active-order-chart
    [data]="orderResCurr"
    [total]="40"
    [order]="activeOrders$ | async"
    [loading]="false"
    class="hidden w-full justify-center self-center md:flex md:flex-1"
  ></app-active-order-chart>
</section>
